<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>Special thanks to the students and staff of Blackburn East Elementary School in Melbourne, Australia, and O’Malley Elementary School in Anchorage, Alaska, for inspiring this story. I also wish to thank the editors and production team of Austin Macauley Publishers, Janine Pyne, Paula Richter, Darleen Starry, Leroy Jeffery, Prince, H. MacKnuckles, Vonjia, and many others for their help and encouragement.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?689e8ce9